import { lastValueFrom } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { ApiService } from '@movilidad/app-core';

import { Ticket } from './ticket.model';

export interface TicketPage {
  data: Ticket[];
  current_page: number;
  last_page: number;
  total: number;
}

export const ticketKeys = {
  all: ['tickets'] as const,
  list: (kind: 'next' | 'previous') => ['tickets', kind] as const,
  detail: (id: number) => ['tickets', 'detail', id] as const,
};

interface CancelResponse {
  success?: boolean;
  error?: string;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class TicketsApi {
  private readonly api = inject(ApiService);

  list(kind: 'next' | 'previous', page: number): Promise<TicketPage> {
    return lastValueFrom(this.api.get<TicketPage>(`bustickets/${kind}`, { page }));
  }

  async detail(id: number): Promise<Ticket> {
    const response = await lastValueFrom(this.api.get<{ data: Ticket }>(`bustickets/${id}`));
    return response.data;
  }

  /** El API también rechaza con 200 y `success: false`: aquí eso es un error, con su mensaje. */
  async cancel(id: number): Promise<void> {
    const response = (await lastValueFrom(this.api.put(`bustickets/${id}`, {}))) as CancelResponse;
    if (response?.success === false) throw new Error(response.error ?? 'El boleto no se pudo cancelar.');
  }
}
